import { render, staticRenderFns } from "./app-versions.vue?vue&type=template&id=9cd41958&scoped=true&"
import script from "./app-versions.vue?vue&type=script&lang=js&"
export * from "./app-versions.vue?vue&type=script&lang=js&"
import style0 from "./app-versions.vue?vue&type=style&index=0&id=9cd41958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd41958",
  null
  
)

export default component.exports